import { render, staticRenderFns } from "./components.vue?vue&type=template&id=52527e33"
import script from "./components.vue?vue&type=script&lang=js"
export * from "./components.vue?vue&type=script&lang=js"
import style0 from "./components.vue?vue&type=style&index=0&id=52527e33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports